export default __webpack_public_path__ + "static/media/Who_We_Are_2.983bd82e.png";